module.exports = __webpack_public_path__ + "img/test04-1.737cb688.jpg";